import "./style.scss";
import { Typography, Box, IconButton, Dialog, DialogContent, Button } from "@mui/material"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import CloseIcon from '@mui/icons-material/Close';

import Cookies from 'js-cookie';

import promoVideo from "../../static/images/promos/blacknovember.mp4"
import promoImage from "../../static/images/promos/summer2026.jpg"
import { getUserDiscountCodes } from "../../util/api/userApi";

const COOKIE_NAME = "spring2026_seen"

export const PromoPopup = ({ open, onClose }) => {
  return <Dialog open={open} onClose={onClose}
    PaperProps={{
      elevation: 10,
    }}
  >
    <IconButton
      aria-label="close"
      onClick={onClose}
      sx={(theme) => ({
        position: 'absolute',
        right: 8,
        top: 8,
        color: "white",
      })}
    > <CloseIcon /></IconButton>
    <img src={promoImage} />

    {/* <video autoPlay muted loop>
      <source src={promoVideo} type="video/mp4"></source>
    </video> */}

    <DialogContent sx={{ justifyContent: "center", textAlign: "center", background: "black", color: 'rgb(249,245,238)' }} >
      <Box>
        <i>Summer Sale</i> is here! <br />Claim <b>30% discount</b> with code SUMMER30 at checkout
      </Box>

      <Box sx={{ mt: 3 }}>
        <Button
          color="primary"
          variant="contained"
          sx={{
            background: "white",
            color: "black",
          }}
          onClick={() => { Cookies.set(COOKIE_NAME, 'true', { expires: 7 }); window.location.href = "/software" }}>Shop Now</Button>
      </Box>
    </DialogContent>
  </Dialog >
}

export const DistantDiscountBanner = () => {
  const token = useSelector((state) => state?.token);
  const [discount, setDiscount] = useState(null);
  const isLoggedIn = Boolean(token?.raw?.access_token)
    && token?.data?.exp >= Date.now() / 1000;

  useEffect(() => {
    let active = true;
    if (!isLoggedIn) {
      setDiscount(null);
      return () => {
        active = false;
      };
    }

    getUserDiscountCodes().then((response) => {
      if (active) {
        setDiscount(response.data.find((item) => item.product_id === "distant-bass-suite") || null);
      }
    }).catch(() => {
      if (active) {
        setDiscount(null);
      }
    });

    return () => {
      active = false;
    };
  }, [isLoggedIn]);

  return (
    <Box
      role="region"
      aria-label="Distant owner discount"
      sx={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "center",
        alignItems: "center",
        gap: { xs: 1, sm: 2 },
        px: 2,
        py: { xs: 1.25, sm: 1.5 },
        pb: { xs: "calc(10px + env(safe-area-inset-bottom))", sm: 1.5 },
        color: "white",
        textAlign: "center",
        background: "linear-gradient(90deg, #8f1119 0%, #d32a24 50%, #8f1119 100%)",
        zIndex: (theme) => theme.zIndex.snackbar,
      }}
    >
      {discount ? <Typography sx={{ fontSize: { xs: "0.875rem", sm: "1rem", md: "1.125rem" }, lineHeight: 1.35 }}>
        Your one-time <b>{discount.percent_off}% BassSuite - Distant discount</b>: <b>{discount.code}</b>
      </Typography> : <Typography sx={{ fontSize: { xs: "0.875rem", sm: "1rem", md: "1.125rem" }, lineHeight: 1.35 }}>
        Own <b>ToneSuite - Distant</b>? Find your discount code for <b>BassSuite - Distant</b> in your account.
      </Typography>}
      <Button
        href={discount ? "/product/distant-bass-suite" : "/account"}
        variant="contained"
        sx={{
          flexShrink: 0,
          minWidth: "auto",
          px: 2,
          py: 0.5,
          color: "#8f1119",
          backgroundColor: "white",
          fontWeight: 700,
          "&:hover": { backgroundColor: "#f5e9e7" },
        }}
      >
        {discount ? "Shop now" : isLoggedIn ? "View account" : "Log in"}
      </Button>
    </Box>
  )
}


export const PromoPopupHandler = () => {
  const [promoOpen, setPromoOpen] = useState(false);
  const [showPromoBanner, setShowPromoBanner] = useState(false);

  useEffect(() => {
    let cookieSet = Cookies.get(COOKIE_NAME);
    if (cookieSet) {
      setPromoOpen(false);
      setShowPromoBanner(true);
      return undefined;
    }

    const promoTimer = window.setTimeout(() => {
      setPromoOpen(true);
    }, 666);

    return () => window.clearTimeout(promoTimer);
  }, []);

  return (
    <>
      <PromoPopup open={promoOpen && !showPromoBanner} onClose={() => { setPromoOpen(false); setShowPromoBanner(true); Cookies.set(COOKIE_NAME, 'true', { expires: 31 }); }} />

      {showPromoBanner && <DistantDiscountBanner />}
    </>
  )
}


